import auth from './auth';
import chat from './chat';
import faq from './faq';
import { store as home } from "@/views/home";
import snackbar from './snackbar';
import nps from './nps';
import pesquisa from './pesquisa';
import notification from './notification';
export default {
  auth: auth,
  chat: chat,
  faq: faq,
  home: home,
  snackbar: snackbar,
  nps: nps,
  pesquisa: pesquisa,
  notification: notification
};